import { makeRequest } from 'utils/requestLogger';

export default (rt_id, body) =>
  makeRequest('put', `/api/roundtables/${rt_id}/allow-sharing`, body);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/dataVisualization/allowSharing.js